export default "__VITE_ASSET__BabOpcgG__"